import { css } from '@emotion/react';

import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const sideBarWrapper = (
  height: number,
  adLoaded = false,
  overflow = false
) => css`
  ${flex('column')};
  width: 35%;
  display: none;
  height: ${height}px;
  transition: height 0.5s ease;
  ${overflow ? '' : 'overflow-y: auto;'}
  ${MQ.MediaLg} {
    display: block;
    width: 35%;
  }
  ${MQ.MediaXl} {
    width: 30%;
  }
  .companionAdATF {
    ${adLoaded ? 'height: 290px' : ''};
    width: 80%;
    overflow: hidden;

    &.companionAdBanner {
      max-width: 300px;
      height: auto;
      min-height: 250px;
      overflow: visible;
      margin-bottom: 10px;

      & + h2 {
        & + .recommendVideoWrap {
          top: 312px;
        }
      }
    }
  }
`;
